import { isPlatformBrowser } from '@angular/common'
import { PLATFORM_ID, inject } from '@angular/core'
import type {
  ActivatedRouteSnapshot,
  CanActivateFn,
  RouterStateSnapshot,
} from '@angular/router'
import { Router } from '@angular/router'

import { map } from 'rxjs'

import { AuthService } from '../services/auth/auth.service'

export const articlePurchaseCheckoutGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
) => {
  const platformId = inject(PLATFORM_ID)
  const router = inject(Router)
  const authService = inject(AuthService)

  if (!isPlatformBrowser(platformId)) {
    return true
  }

  return authService.waitForAuthCheckCompletion().pipe(
    map(() => {
      const returnUrl = state.url
      const articleId = route.paramMap.get('id')

      if (!authService.isAuthenticated()) {
        return router.createUrlTree([
          '/articles',
          articleId,
          'purchase',
          'account',
          'register',
        ])
      }

      const user = authService.currentUser()
      if (!user) {
        return router.createUrlTree(['/auth/login'], {
          queryParams: { returnUrl },
        })
      }

      if (user.managed) {
        return router.createUrlTree([
          '/articles',
          articleId,
          'purchase',
          'account',
          'update',
        ])
      }

      if (user._verified !== true) {
        return router.createUrlTree(
          ['/articles', articleId, 'purchase', 'account', 'verify'],
          {
            queryParams: {
              email: user.email ?? undefined,
              mode: 'update',
            },
          }
        )
      }

      return true
    })
  )
}
